module.exports = __webpack_public_path__ + "static/media/section-banner-8.91c7630e.svg";